import { Skeleton } from '../../../shadcn/components/skeleton';

function InboxMessageSkeleton() {
  return (
    <div className="flex flex-col" data-testid="inbox-message-skeleton">
      <Skeleton className="h-6 w-40 mt-1" data-testid="inbox-message-skeleton-header" />
      <Skeleton className="h-9 w-full mt-1" data-testid="inbox-message-skeleton-title" />
      <Skeleton className="h-36 w-full rounded-lg mt-5" data-testid="inbox-message-skeleton-content" />
      <div className="space-y-3 mt-5" data-testid="inbox-message-skeleton-text-lines">
        <Skeleton className="h-4 w-full" data-testid="inbox-message-skeleton-text-line-1" />
        <Skeleton className="h-4 w-full" data-testid="inbox-message-skeleton-text-line-2" />
        <Skeleton className="h-4 w-full" data-testid="inbox-message-skeleton-text-line-3" />
        <Skeleton className="h-4 w-4/5" data-testid="inbox-message-skeleton-text-line-4" />
        <Skeleton className="h-4 w-3/4" data-testid="inbox-message-skeleton-text-line-5" />
        <Skeleton className="h-4 w-full" data-testid="inbox-message-skeleton-text-line-6" />
        <Skeleton className="h-4 w-2/3" data-testid="inbox-message-skeleton-text-line-7" />
      </div>
      <div
        className="fixed bottom-0 left-0 right-0 z-50 p-5 border-t shadow-lg rounded-t-lg md:static md:p-0 md:shadow-none md:border-none md:mt-5"
        data-testid="inbox-message-skeleton-button-container"
      >
        <Skeleton className="h-12 w-full rounded-md" data-testid="inbox-message-skeleton-button" />
      </div>
    </div>
  );
}

export { InboxMessageSkeleton };
